import React from 'react';
import BooksListing from '../BooksListing/BooksListing';

export default function FavoritesBooks() {
	return (
		<div>
			<BooksListing favorites />
		</div>
	);
}
